import React from "react";
import PlacementItem from "./PlacementItem";
import PreviewPlacementHighlighter from "../../preview/PreviewPlacementHighlighter";
import { CmLinkableType } from "../../types";

import type { CAEGlobalSettings } from "../../../types/CAEGlobalSettings";

interface Props {
    placementName: string,
    items: Array<CmLinkableType>,
    viewtype: string,
    CAEGlobalSettings: CAEGlobalSettings,
    csrfToken: string,
    isPreview?: boolean,
    placeholderContent?: any,
    pageSettings?: any,
    credentials?: any,
    donationInitializerData?: { queryData: any; isProduct: boolean; contentId: string } | null
}

function PageGridPlacement(props: Props) {
    return <PreviewPlacementHighlighter placementName={props.placementName} hasItems={!!props.items}>
        {props.items.map((i, index) => (
            <PlacementItem key={index}
                           item={i}
                           CAEGlobalSettings={props.CAEGlobalSettings}
                           csrfToken={props.csrfToken}
                           isPreview={props.isPreview}
                           placeholderContent={props.placeholderContent}
                           pageSettings={props.pageSettings}
                           credentials={props.credentials}
                           donationInitializerData={props.donationInitializerData}/>
        ))}
    </PreviewPlacementHighlighter>
}

export default PageGridPlacement